import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import NotificationTabs from "./NotificationTabs/NotificationTabs";
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import Badge from "@material-ui/core/Badge";
import { useRecoilValue } from 'recoil';
import { unreadNotificationCount } from '../../../recoil-store/recoil-state';

import './notification.css';

const useStyles = makeStyles({
    list: {
        width: 250,
    },
    fullList: {
        width: "auto",
    },
    tabs: {
        width: "100%",
    },
    badge: {
        backgroundColor: '#f64e60',
        color: '#fff',
    }
});

function Notification() {
    const classes = useStyles();

    const [state, setState] = useState({
        right: false,
    });
    const count = useRecoilValue(unreadNotificationCount)

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setState({ ...state, right: open });
    };

    const list = (anchor) => (
        <div
            className={`${clsx(classes.list, {
                [classes.fullList]: anchor === "top" || anchor === "bottom",
            })} ${classes.tabs}`}
            role="presentation"
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <NotificationTabs toggleDrawer={toggleDrawer} />
        </div>
    );

    return (
        <div>
            <>
                <Button onClick={toggleDrawer("right", true)}>
                    <Badge
                        badgeContent={count > 0 ? count : undefined}
                        classes={{ badge: classes.badge }}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                    >
                        <NotificationsNoneIcon style={{ color: "white" }} className={count > 0 ? 'pulse' : ''} />
                    </Badge>
                </Button>
                <Drawer
                    anchor={"right"}
                    open={state["right"]}
                    onClose={toggleDrawer("right", false)}
                >
                    {state["right"] && list("right")}
                </Drawer>
            </>
        </div>
    );
}

export default Notification;
